import React, { useEffect, useState } from 'react';
import { Fab } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { motion, AnimatePresence } from 'framer-motion';
import { COLORS } from '../../constants/Colors';

const BackToTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => setVisible(window.scrollY > 300);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ opacity: 0, scale: 0.6 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.6 }}
                    transition={{ duration: 0.25 }}
                    style={{ position: 'fixed', bottom: '5vh', right: '3vw', zIndex: 999 }}
                >
                    <Fab
                        onClick={handleClick}
                        size="medium"
                        sx={{
                            backgroundColor: COLORS.blueE7,
                            color: COLORS.white,
                            boxShadow: '0 4px 16px rgba(41,97,231,0.35)',
                            '&:hover': {
                                backgroundColor: COLORS.blueD4,
                                transform: 'translateY(-3px)',
                                boxShadow: '0 8px 24px rgba(41,97,231,0.4)',
                            },
                            transition: 'transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease',
                        }}
                    >
                        <KeyboardArrowUpIcon />
                    </Fab>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default BackToTop;
